package com.cs.ejobin.data.supabase

import com.cs.ejobin.data.AuthRepository
import com.cs.ejobin.data.SignupResult
import com.cs.ejobin.data.supabase.dto.ProfileRow
import com.cs.ejobin.model.Skill
import com.cs.ejobin.model.UserProfile
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.auth.providers.builtin.Email
import io.github.jan.supabase.postgrest.from
import kotlinx.serialization.json.*

class SupabaseAuthRepository(
    private val supabase: SupabaseClient,
    private val redirectTo: String
) : AuthRepository {

    override suspend fun login(email: String, password: String): UserProfile {
        supabase.auth.signInWith(Email) {
            this.email = email
            this.password = password
        }
        return fetchMyProfile()
    }

    override suspend fun signup(
        email: String,
        password: String,
        name: String,
        phone: String,
        skills: List<String>,
        description: String?,
    ): SignupResult {

        supabase.auth.signUpWith(Email) {
            this.email = email
            this.password = password
            data = buildJsonObject {
                put("name", name)
                put("phone", phone)
                put("skills", JsonArray(skills.map { JsonPrimitive(it) }))
                put("description", description.orEmpty())
            }
        }

        val user = supabase.auth.currentUserOrNull()
        return if (user != null) {
            SignupResult.SignedIn(fetchMyProfile())
        } else {
            SignupResult.NeedsEmailConfirmation
        }
    }

    override suspend fun requestPasswordReset(email: String) {
        supabase.auth.resetPasswordForEmail(email, redirectUrl = redirectTo)
    }

    override suspend fun updatePassword(newPassword: String) {
        supabase.auth.updateUser { password = newPassword }
    }

    override suspend fun logout() {
        supabase.auth.signOut()
    }

    private suspend fun fetchMyProfile(): UserProfile {
        val user = supabase.auth.currentUserOrNull()
            ?: error("Utilisateur non authentifié")

        val row = supabase.from("profiles")
            .select { filter { eq("id", user.id) } }
            .decodeSingle<ProfileRow>()

        return UserProfile(
            id = row.id,
            email = user.email ?: "",
            name = row.name,
            phone = row.phone,
            isAvailable = row.isAvailable,
            photoUrl = row.photoUrl,
            skills = row.skills.mapIndexed { idx, s -> Skill("db$idx", s) },
            description = row.description,
        )
    }
}